var r={exports:{}};export{r as d};
//# sourceMappingURL=duration.js.map
